import * as React from 'react';

export function LoadingSpinner() {
    return (
        <div className="adage-loader-container">
            <svg width={90} height={90} viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg" className="adage-loader">
             <path
                 d="M58 30.5C58 15.3122 45.6878 3 30.5 3C15.3122 3 3 15.3122 3 30.5"
                 stroke="#13294B"
                 strokeWidth={5}
                 strokeLinejoin="round"
             />
             <circle cx="30.5" cy="30.5" r="27.5" stroke="url(#gradient)" strokeWidth={5} />
             <defs>
                 <linearGradient id="gradient" x1="12.5" y1={53} x2={56} y2={45} gradientUnits="userSpaceOnUse">
                     <stop stopColor="#13294B" />
                     <stop offset={1} stopColor="#13294B" stopOpacity={0} />
                 </linearGradient>
             </defs>
            </svg>
        </div>
    );
};
